import React, {useEffect, useState} from "react"
import "./wallets.scss"
import {createWallet, getWallets, setDefaultOrDeleteWallet} from "services/ecrpyt"
import {useApiDefaults} from "hooks/useApiDefaults"
import Loader from "components/Loader"
import { EcryptIframe } from 'routes/checkout/CheckoutInfo/CheckoutInformation/ECryptPaymentGateway'
import { useSelector } from 'react-redux'

const Actions = {
  update: "update",
  delete: "delete"
}

const Wallets = () => {
  const [wallets, setWallets] = useState(null)
  const [loading, setLoading] = useState(false)
  const apiDefualts = useApiDefaults()

  const [action, setAction] = useState("")
  const [walletId, setWalletId] = useState("")
  const [message, setMessage] = useState({
    text: "",
    type: ""
  })

  const [showNewCreditCardModal, setShowNewCreditCardModal] = useState(false)
  const [isDefaultCard, setIsDefaultCard] = useState(false)
  const [token, setToken] = useState(null)
  const [AddCardMessage, setAddCardMessage] = useState({
    type: "",
    message: ""
  })
  const [savingCard, setSavingCard] = useState(false)

  const fetchWallets = async () => {
    setLoading(true)
    const {data} = await getWallets(apiDefualts)
    setWallets(data)
    setLoading(false)
  }

  useEffect(() => {
    fetchWallets()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function handleSetDefaultOrDeleteClick(wallet_id, action) {
    setMessage({text: "", type: ""})
    
    const {error, message} = await setDefaultOrDeleteWallet({...apiDefualts, wallet_id, action})
    if (error) {
      setMessage({text: message, type: "error"})
    } else {
      setMessage({text: message, type: "success"})
    }

    setAction("")
    setWalletId("")
    fetchWallets()

    setTimeout(() => {
      setMessage({text: "", type: ""})
    }, 3000)
  }

  async function handleAddNewCard() {
    try {
      setSavingCard(true)
      setAddCardMessage({
        type: "",
        message: "",
      })

      if (savingCard) {
        return
      }

      const {error, message} = await createWallet({
        ...apiDefualts,
        token,
        is_default: isDefaultCard ? 1 : 0,
        meal_order_id: "",
        order_id: "",
      })
      if (error) {
        setAddCardMessage({
          type: "error",
          message: message,
        })
      } else {
        setAddCardMessage({
          type: "success",
          message: message,
        })
        setTimeout(() => {
          setAddCardMessage({
            type: "",
            message: "",
          })
          setShowNewCreditCardModal(false)
        }, 2000)
        fetchWallets()
      }
    } catch (error) {
      console.error(error)
    } finally {
      setSavingCard(false)
    }
  }

  return (
    <div className="wallets-section-theme2">
      {showNewCreditCardModal && (
        <NewCreditCardModal
          setToken={setToken}
          onClose={() => {
            setShowNewCreditCardModal(false)
            setSavingCard(false)
          }}
          addCardMessage={AddCardMessage}
          token={token}
          handleAddNewCard={handleAddNewCard}
          savingCard={savingCard}
          isDefaultCard={isDefaultCard}
          setIsDefaultCard={setIsDefaultCard}
        />
      )}
      <div className="page-title">
        <h1>Wallets</h1>
      </div>

          {message.text ? <div className={`message ${message.type}-message`}>{message.text}</div> : null}
          <div className="add-btn-wrap">
          <button onClick={() => setShowNewCreditCardModal(true)} className="add-btn">Add New Card</button>
          </div>
      <div className="table-wrapper">
        <div className="scrollable">
          <table className="responsive">
            <tbody>
              <tr>
                <th align="left">Card Type</th>
                <th align="left">Account Number</th>
                <th align="left">Expiry</th>
                <th align="center">Action</th>
              </tr>
              {loading ? (
                <tr>
                  <td colSpan={4}>
                    <Loader />
                  </td>
                </tr>
              ) : null}
              {wallets?.map(card => (
                <tr key={card.id} className="table-detail">
                  <td>{card.network}</td>
                  <td>
                    {card.account_number}
                    {card.default ? (
                      <span className="default-badge">Default</span>
                    ) : null}
                  </td>
                  <td>{card.expiry}</td>
                  <td>
                    <div className="action-btn">
                      {card.default ? null : (
                        <button
                          className="defult-btn"
                          disabled={action}
                          onClick={() => {
                            setAction(Actions.update)
                            setWalletId(card.id)
                            handleSetDefaultOrDeleteClick(card.id, Actions.update)
                          }}
                        >
                          {action === Actions.update && walletId === card.id ? "Updating..." : "Set as default"}
                        </button>
                      )}
                      {card.allow_delete == 1 && <button
                        className="delete"
                        disabled={action}
                        onClick={() => {
                          setAction(Actions.delete)
                          setWalletId(card.id)
                          handleSetDefaultOrDeleteClick(card.id, Actions.delete)
                        }}
                      >
                        {action === Actions.delete && walletId === card.id ? "Deleting..." : "Delete"}
                      </button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

function NewCreditCardModal({
  setToken,
  onClose,
  addCardMessage,
  token,
  handleAddNewCard,
  savingCard,
  isDefaultCard,
  setIsDefaultCard,
}) {
  const {storeDetails} = useSelector(({store}) => store)
  return (
    <div className="modal-backdrop payment-model-wrap">
      <div className="modal-lg place-order-popup store-payment-modal">
        <span className="help-text">
          Please enter credit card details below
        </span>

        <EcryptIframe setToken={setToken} storeDetails={storeDetails} />
        <div className="close-btn" onClick={onClose} title="Close">
          <i className="fa-solid fa-xmark"></i>
        </div>

        <div className="save-card-wrap">
          <input
            type="checkbox"
            id="save_card"
            checked={isDefaultCard}
            onChange={e => setIsDefaultCard(e.target.checked)}
          />
          <label
            htmlFor="save_card"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p>Make this default payment method</p>
          </label>
        </div>

        {addCardMessage.message && (
          <div
            className={`${
              addCardMessage.type === "error" ? "error-msg" : "success-msg"
            }`}
            style={{marginBottom: "12px"}}
          >
            {addCardMessage.message}
          </div>
        )}

        <div className="pay-btn-wrap">
          <button
            disabled={!token || savingCard}
            onClick={handleAddNewCard}
            className={`${!token ? "pay-btn-disabled" : "pay-btn "}`}
          >
            {savingCard ? "Saving..." : "Save Card"}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Wallets
